import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Title = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.title};
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.rule.greyLight};
  text-align: center;
  font-weight: normal;
`;

export const Content = styled.div`
  height: calc(100% - 80px);

  @media ${({ theme }) => theme.device.mobile} {
    padding: 24px 16px;
    background-color: ${ColorPalette.HEX.Lotion};
  }

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 16px;
  }
`;
